import { atom } from 'recoil';
import { getAppLocalStorage } from 'shared/appLocalStorage';

const darkModeStateKey = 'darkMode';

export const darkModeState = atom({
  key: darkModeStateKey,
  default: getAppLocalStorage().darkMode
});
